import "aos/dist/aos.css";
import React from "react";

export default function ModalCloseButton( {close, ...props} ){
  return <div className="position-absolute btn btn-close-white text-secondary" style={{right: "0px", top: "0px", zIndex: "1"}} onClick={typeof close==='function' ? close : undefined}>
    <span className="fs-3 mdi mdi-close-circle-outline"></span>
  </div>;
}
